import React from 'react';
import { Outlet } from 'react-router-dom';

const SubscriberWalletLayout = () => {
  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
};

export default SubscriberWalletLayout;

